export default "__VITE_ASSET__DXyzJvt9__"